module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-63c3b709!./packages/dof-popup/colmo.css
// module id = 502
// module chunks = 0 1